export default function getTemplate(props, templateName) {
  // grab template from the props and return the function

  return props.customTemplates[templateName];
}
